﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidControllerABI = void 0;
class LiquidControllerABI {
    static GetABI() {
        return [
            {
                "inputs": [],
                "name": "deposit",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_manager",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "_owner",
                        "type": "address"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "constructor"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "previousManager",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "newManager",
                        "type": "address"
                    }
                ],
                "name": "ManagmentshipTransferred",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "previousOwner",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "newOwner",
                        "type": "address"
                    }
                ],
                "name": "OwnershipTransferred",
                "type": "event"
            },
            {
                "inputs": [],
                "name": "renounceManagmentship",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "renounceOwnership",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "_llMinLoan",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_llGas",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_loanMinReTakeUSDL",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_swapMinUSDL",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_maxLoanDumpIndex",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_stabPoolSplitPartRevers",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_buyBurnSplitPartRevers",
                        "type": "uint256"
                    }
                ],
                "name": "setConfig",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "_targetICR",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_targetReloanICR",
                        "type": "uint256"
                    }
                ],
                "name": "setTargetICR",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "newManager",
                        "type": "address"
                    }
                ],
                "name": "transferManagmentship",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "newOwner",
                        "type": "address"
                    }
                ],
                "name": "transferOwnership",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "stateMutability": "payable",
                "type": "fallback"
            },
            {
                "inputs": [],
                "name": "update",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "updateInfrastructure",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "withdraw",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "erc20Address",
                        "type": "address"
                    }
                ],
                "name": "withdrawToken",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "stateMutability": "payable",
                "type": "receive"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "_targetICR",
                        "type": "uint256"
                    }
                ],
                "name": "calcAdditionalLoanSize",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "_loan",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_coll",
                        "type": "uint256"
                    }
                ],
                "name": "calcICR",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "_targetICR",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_coll",
                        "type": "uint256"
                    }
                ],
                "name": "calcLoanSize",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getBalance",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "erc20Address",
                        "type": "address"
                    }
                ],
                "name": "getBalanceToken",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getColl",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getConfig",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "_llMinLoan",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_llGas",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_loanMinReTakeUSDL",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_swapMinUSDL",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_maxLoanDumpIndex",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_targetICR",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_targetReloanICR",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_stabPoolSplitPartRevers",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_buyBurnSplitPartRevers",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getDebt",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getICR",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getManager",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getOwner",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getStatus",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "needUpdate",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "vaultProxy",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            }
        ];
    }
}
exports.LiquidControllerABI = LiquidControllerABI;
//# sourceMappingURL=LiquidControllerABI.js.map